import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CART_VALIDATION_NORMALIZER } from '@spartacus/cart/base/core';
import { Cart, CART_NORMALIZER, CartModificationList } from '@spartacus/cart/base/root';
import { ConverterService, Occ, OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { GenAutoShipEntriesRequest, GenAutoShipScheduleDates } from '../../../models/auto-ship.model';
import { GenAutoShipCartAdapter } from '../core/connectors/auto-ship-cart.adapter';

@Injectable()
export class GenOccAutoShipCartAdapter implements GenAutoShipCartAdapter {
  constructor(
    private http: HttpClient,
    private occEndpoints: OccEndpointsService,
    private converter: ConverterService,
  ) { }

  load(userId: string, cartId: string): Observable<Cart> {
    return this.http
      .get<Occ.Cart>(
        this.occEndpoints.buildUrl('cart', {
          urlParams: { userId, cartId },
        }),
      )
      .pipe(this.converter.pipeable(CART_NORMALIZER));
  }

  updateEntries(
    userId: string,
    cartId: string,
    request: GenAutoShipEntriesRequest,
  ): Observable<CartModificationList> {
    return this.http
      .post<CartModificationList>(
        this.occEndpoints.buildUrl('autoShipCartEntries', {
          urlParams: { userId, cartId },
        }),
        request,
      )
      .pipe(this.converter.pipeable(CART_VALIDATION_NORMALIZER));
  }

  scheduleShipment(
    userId: string,
    cartId: string,
    request: GenAutoShipScheduleDates,
  ): Observable<unknown> {
    return this.http
      .post<unknown>(
        this.occEndpoints.buildUrl('autoShipCartShipments', {
          urlParams: { userId, cartId },
        }),
        request,
      );
  }
}
